import {Inject, Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ErrorCodes } from '../Models/EnumModels';
import { AppSettings } from '../Library/AppSettings';
import { debounce } from "lodash";
import {DOCUMENT} from "@angular/common";
import {UFWindow} from "../Models/UFAppEnvironmentModels";
import {CookieService} from "ngx-cookie-service";
declare var $: any;
declare var Spinner: any;
declare var dataLayer: any;

@Injectable()
export class APIServiceConnector {
    public baseURL = "/";
    _spinner: any;
    opts: any;
    PendingCalls: number;
    private window: UFWindow;

    apiLogoutHandler = debounce(
        () => {
            alert("Invalid Session or Session expired. Please login again");
            AppSettings.EnableUnifocusSSO ? this.signOutUser() : window.location.assign(AppSettings.URL_Central);
        },
        5_000
    );

    apiForbiddenHandler = debounce(
        () => {
            alert(
                "Access from current IP address is not allowed. Please contact system administrator."
            );
            AppSettings.EnableUnifocusSSO ? this.signOutUser() : window.location.assign(AppSettings.URL_Central);
        },
        5_000
    );
    constructor(
        private http: HttpClient,
        private spinnerService: Ng4LoadingSpinnerService,
        private cookieService: CookieService,
        @Inject(DOCUMENT) private readonly document: Document
    ) {
        this.window = this.document.defaultView as UFWindow;
        this.PendingCalls = 0;
        this.SetUnifocusSSO();
        if (!AppSettings.EnableUnifocusSSO && !this.getSessionCookie()) {
            window.location.assign("/home");
        }
    }
    getCookie(name: string): string {
        return this.cookieService.get(name);
    }

    setCookie(name: string, value: string, expires = 1) {
        this.cookieService.set(name, value, expires, '/', AppSettings.Domain, true, "Lax");
    }

    deleteCookie(name: string) {
        this.cookieService.set(name, "", new Date("Thu, 01 Jan 1970 00:00:01 GMT"), '/', AppSettings.Domain, true, "Lax");
    }

    getSessionCookie() {
        return this.getCookie("SessionID") || this.getCookie("SessionId");
    }

    signOutUser() {
        if (AppSettings.EnableUnifocusSSO) {
            const ufLogout = () => {
                // for api used in frontend,
                // set here because delete_loggedInUser needs SessionID
                // for reports
                this.deleteCookie("_windows");
                // for /pages middleware logout
                this.deleteCookie("SessionId");
                // for backup
                this.deleteCookie("SessionID");
                // for authorization-token
                this.window.unifocus && this.window.unifocus.signOut(window.location.origin);
            };
            // for loggedInUser
            this.Delete_LoggedInUser().then(ufLogout, ufLogout);

        } else {
            window.location.href = "/Pages/UserLogout";
        }
    }

    private Delete_LoggedInUser() {
        return this.postAPI(AppSettings.URL_Session, "Session/Delete_LoggedInUser", null);
    }

    SetBaseURL(URL: string): void {
        this.baseURL = URL;
    }

    apiErrorHandler(response) {
        if (response != null) {
            let preCheck: any = response;

            if (
                preCheck.HasError &&
                preCheck.HasError == true &&
                preCheck.Errors != null
            ) {
                if (
                    preCheck.Errors.findIndex(
                        (a) => a.ErrorCode == ErrorCodes.InvalidUserToken
                    ) >= 0
                ) {
                    this.apiLogoutHandler();
                }
                if (
                    preCheck.Errors.findIndex(
                        (a) => a.ErrorCode == ErrorCodes.ForbiddenAccess
                    ) >= 0
                ) {
                    this.apiForbiddenHandler();
                }
            }
        }
    }

    postAPI(
        BaseURL: string,
        URL: string,
        PostData: any,
        trackLoading: boolean = true
    ): Promise<any> {
        dataLayer.push({
            event: "API",
            URL: URL,
            APIData: JSON.stringify(PostData),
        });

        if (trackLoading) {
            this.ShowSpinner();
            this.PendingCalls++;
        }

        let headers = new HttpHeaders( {
            'X-Requested-With': 'XMLHttpRequest',
        });
        const sessionId = this.getSessionCookie();
        if (sessionId) {
            headers = headers.set('SessionID', sessionId);
        }

        return this.http
            .post(BaseURL + URL, PostData, { headers: headers, withCredentials: true })
            .toPromise()
            .then(
                (response) => {
                    if (trackLoading) {
                        this.PendingCalls--;
                        this.HideSpinner();
                    }

                    this.apiErrorHandler(response);

                    return response;
                },
                (data) => {
                    if (trackLoading) {
                        this.PendingCalls--;
                        this.HideSpinner();
                    }

                    //console.info("E = " + data);
                    return null;
                }
            );
    }

    getAPI(
        BaseURL: string,
        URL: string,
        trackLoading: boolean = true
    ): Promise<any> {
        const Url_withoutQueryString = URL.split("?")[0]; // push without queryString
        dataLayer.push({
            event: "API",
            URL: Url_withoutQueryString,
        });

        if (trackLoading) {
            this.ShowSpinner();
            this.PendingCalls++;
        }

        let headers = new HttpHeaders({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
            'X-Requested-With': 'XMLHttpRequest',
        });
        const sessionId = this.getSessionCookie();
        if (sessionId) {
            headers = headers.set('SessionID', sessionId);
        }

        return this.http
            .get(BaseURL + URL, { headers: headers, withCredentials: true })
            .toPromise()
            .then(
                (response) => {
                    if (trackLoading) {
                        this.PendingCalls--;
                        this.HideSpinner();
                    }

                    this.apiErrorHandler(response);

                    return response;
                },
                (reason) => {
                    console.info(reason);
                    if (trackLoading) {
                        this.PendingCalls--;
                        this.HideSpinner();
                    }

                    return null;
                }
            );
    }

    ShowSpinner(): void {
        this.spinnerService.show();
    }

    HideSpinner(): void {
        if (this.PendingCalls > 0) {
            return;
        }

        this.spinnerService.hide();
    }

    private SetUnifocusSSO() {
        AppSettings.EnableUnifocusSSO = !!this.window.unifocus;
    }
}
